import { SAVE_SECTION, SAVE_SECTION_FAILED, SAVE_SECTION_SUCCESS } from '@state/actions/appActions'
import {
    EXERCISE_CHANGED,
} from '@state/actions/exercisesActions'

const initialExercisesState = {
    isDirty: false,
    isLoading: false,
}

/**
 * Reducer
 */
const exercisesReducer = (state, action) => {
    switch (action.type) {
        case EXERCISE_CHANGED:
            return {
                ...state,
                isDirty: true,
            }
        case SAVE_SECTION:
            return {
                ...state,
                isLoading: true,
            }
        case SAVE_SECTION_SUCCESS:
            return {
                ...state,
                isDirty: false,
                isLoading: false,
            }
        case SAVE_SECTION_FAILED:
            return {
                ...state,
                isLoading: false
            }
        default:
            return state
    }
}

export { initialExercisesState, exercisesReducer }
